import React from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDBox from "@cloudpremise/portal_core/src/themes/mui/components/MDBox";
import MDTypography from "@cloudpremise/portal_core/src/themes/mui/components/MDTypography";
import MDButton from "@cloudpremise/portal_core/src/themes/mui/components/MDButton";

import TerminalOutlinedIcon from '@mui/icons-material/TerminalOutlined';
import SplitscreenOutlinedIcon from '@mui/icons-material/SplitscreenOutlined';
import LanguageOutlinedIcon from '@mui/icons-material/LanguageOutlined';
import MailOutlinedIcon from '@mui/icons-material/MailOutlined';
import ChatBubbleOutlineOutlinedIcon from '@mui/icons-material/ChatBubbleOutlineOutlined';

const Hermes = () => {
    return (
        <Grid container spacing={3} className="hermes-container">
            <Grid item xs={12} md={6} lg={6}>
                <Card>
                    <MDBox p={2}>
                        <MDTypography component="h6" variant="button" fontWeight="bold" color="dark" mb={1}>
                            <TerminalOutlinedIcon /> Hermes CLI
                        </MDTypography>
                        <MDTypography component="p" variant="button" fontWeight="light" color="dark" mb={2}>
                            Download the command line tool for interacting with the Olympus-Grid Messaging Layer.
                        </MDTypography>
                        <MDButton variant="contained" color="dark">
                            Download CLI
                        </MDButton>
                    </MDBox>
                </Card>
            </Grid>
            <Grid item xs={12} md={6} lg={6}>
                <Card>
                    <MDBox p={2}>
                        <MDTypography component="h6" variant="button" fontWeight="bold" color="dark" mb={1}>
                            <SplitscreenOutlinedIcon /> Hermes Bus
                        </MDTypography>
                        <MDTypography component="p" variant="button" fontWeight="light" color="dark" mb={2}>
                            Create, Deploy, Track, Monitor and Optimize your messaging bus and routing rules.
                        </MDTypography>
                        <MDButton variant="outlined" color="light">
                            Launch Hermes Bus
                        </MDButton>
                    </MDBox>
                </Card>
            </Grid>
            <Grid item xs={12} md={6} lg={6}>
                <Card>
                    <MDBox p={2}>
                        <MDTypography component="h6" variant="button" fontWeight="bold" color="dark" mb={1}>
                            <LanguageOutlinedIcon /> Hermes API
                        </MDTypography>
                        <MDTypography component="p" variant="button" fontWeight="light" color="dark" mb={2}>
                            Setup Webhooks, test endpoints and view API logs and activity history.
                        </MDTypography>
                        <MDButton variant="outlined" color="light">
                            Configure API
                        </MDButton>
                    </MDBox>
                </Card>
            </Grid>
            <Grid item xs={12} md={6} lg={6}>
                <Card>
                    <MDBox p={2}>
                        <MDTypography component="h6" variant="button" fontWeight="bold" color="dark" mb={1}>
                            <MailOutlinedIcon /> Email Providers
                        </MDTypography>
                        <MDTypography component="p" variant="button" fontWeight="light" color="dark" mb={2}>
                            Setup and manage Sendgrid, SES, Mailgun or Olympus-native email delivery providers.
                        </MDTypography>
                        <MDButton variant="outlined" color="light">
                            Manage Email
                        </MDButton>
                    </MDBox>
                </Card>
            </Grid>
            <Grid item xs={12} md={6} lg={6}>
                <Card>
                    <MDBox p={2}>
                        <MDTypography component="h6" variant="button" fontWeight="bold" color="dark" mb={1}>
                            <ChatBubbleOutlineOutlinedIcon /> SMS Providers
                        </MDTypography>
                        <MDTypography component="p" variant="button" fontWeight="light" color="dark" mb={2}>
                            Configure SMS delivery with Twilio or Olympus-native SMS messaging.
                        </MDTypography>
                        <MDButton variant="outlined" color="light">
                            Manage SMS
                        </MDButton>
                    </MDBox>
                </Card>
            </Grid>
        </Grid>
    );
};

export default Hermes;